"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientMeta = void 0;
var regexConstants_1 = require("../constants/regexConstants");
var userAgent = navigator.userAgent.toLowerCase();
var isTouch = regexConstants_1.TOUCH_REGEX.test(userAgent);
var isAndroid = regexConstants_1.ANDROID_REGEX.test(userAgent);
var isWebview = regexConstants_1.WEBVIEW_REGEX.test(userAgent);
var isIos = regexConstants_1.IOS_REGEX.test(userAgent);
var isMac = regexConstants_1.MAC_REGEX.test(userAgent);
var platform = isMac ? 'MacBrowser' : 'PcBrowser';
if (isAndroid) {
    platform = 'AndroidBrowser';
    if (isWebview) {
        platform = 'AndroidNative';
    }
}
if (isIos) {
    platform = 'IosBrowser';
    if (isWebview) {
        platform = 'IosNative';
    }
}
var isReactSnap = window.navigator.userAgent === 'ReactSnap';
exports.clientMeta = {
    isTouch: isTouch,
    isAndroid: isAndroid,
    isIos: isIos,
    platform: platform,
    isReactSnap: isReactSnap,
};
